import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CalcOnlyHotelPackageRequest,
  CalcOnlyHotelPackageResponse,
  SearchOnlyHotelPackagesRequest,
  SearchOnlyHotelPackagesResponse
} from '@appTypes/api.types';
import { environment } from '@env/environment';

@Injectable()
export class HotelsApiService {
  readonly #httpClient = inject(HttpClient);

  readonly #apiEndPoint: string = environment.urls.api + '/OnlyHotelPackages/';

  searchHotels(payload: SearchOnlyHotelPackagesRequest) {
    return this.#httpClient.post<SearchOnlyHotelPackagesResponse>(this.#apiEndPoint + 'SearchHotelPrices', payload, {
      reportProgress: true
    });
  }

  calcPackage(payload?: CalcOnlyHotelPackageRequest) {
    return this.#httpClient.post<CalcOnlyHotelPackageResponse>(this.#apiEndPoint + 'CalcPackage', payload);
  }
}
